
import { Suspense } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import MissionSection from './components/MissionSection';
import StorySection from './components/StorySection';
import TeamSection from './components/TeamSection';
import { useSEO, SITE_URL } from '../../hooks/useSEO';

const OurStoryPage = () => {
  useSEO({
    title: 'Our Story — Cybersecurity Experts for Mortgage Firms | Mortgage Moat',
    description: 'Learn how Mortgage Moat was founded to protect financial firms from cyber threats. Meet the cybersecurity experts dedicated to securing the mortgage industry nationwide.',
    keywords: 'Mortgage Moat story, cybersecurity company, mortgage security experts, about Mortgage Moat',
    canonical: '/our-story',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: 'Our Story — Mortgage Moat',
        url: `${SITE_URL}/our-story`,
        description: 'The story behind Mortgage Moat and our mission to protect financial firms from cyber threats.',
        publisher: { '@type': 'Organization', name: 'Mortgage Moat', url: SITE_URL },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
          { '@type': 'ListItem', position: 2, name: 'Our Story', item: `${SITE_URL}/our-story` },
        ],
      },
    ],
  });

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen flex flex-col bg-white">
        <Header />
        <main className="flex-grow">
          <MissionSection />
          <StorySection />
          <TeamSection />
        </main>
        <Footer />
      </div>
    </Suspense>
  );
};

export default OurStoryPage;
